import React from 'react';
import '../template-file-css/document-file-template.css';

export const GENERAL_OutpatientTreatmentRequest = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='GENERAL_OutpatientTreatmentRequest' className='file-pdf-document'>
            <div className='file-template'>
                <h3>Instructions
                </h3>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>Submit these documents:</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLiving1_Home" name="chkLiving1_Home" className='add-only' value="Living1" />
                            This Outpatient Treatment Request form
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLiving2_Home" name="chkLiving2_Home" className='add-only' value="Living2" />
                            LOCUS/CALOCUS Assessment (completed within last 180 days)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLiving3_Home" name="chkLiving3_Home" className='add-only' value="Living3" />
                            Treatment Plan
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLiving4_Home" name="chkLiving4_Home" className='add-only' value="Living4" />
                            Healthy Louisiana Behavioral Health Assessment (annually)
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLiving5_Home" name="chkLiving5_Home" className='add-only' value="Living5" />
                            Complete all questions to prevent delay in processing and determination.
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLiving6_Home" name="chkLiving6_Home" className='add-only' value="Living6" />
                            Member Choice Form
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <strong>By fax to: 1-888-725-0101</strong>
                </p>
                <p className='w-750'>
                    This form is for CPST or PSR.
                </p>
                <p className='w-750'>
                    <strong>Renewal every 60 days may be requested using this form.</strong>
                </p>
                <h3>Provider Information</h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician:</span>
                            <input type='text' id="txtClinician" name="txtClinician" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Credentials:</span>
                            <input type='text' id="txtCredentials" name="txtCredentials" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency Name:</span>
                            <input type='text' id="txtAgencyName" name="txtAgencyName" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency Phone:</span>
                            <input type='text' id="txtClinician1" name="txtClinician1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency Secure Fax:</span>
                            <input type='text' id="txtCredentials1" name="txtCredentials1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency NPI:</span>
                            <input type='text' id="txtAgencyName1" name="txtAgencyName1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency TIN:</span>
                            <input type='text' id="txtClinician2" name="txtClinician2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Agency Address:</span>
                            <input type='text' id="txtCredentials2" name="txtCredentials2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>City:</span>
                            <input type='text' id="txtAgencyName2" name="txtAgencyName2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>State:</span>
                            <input type='text' id="txtClinician3" name="txtClinician3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Zip:</span>
                            <input type='text' id="txtCredentials3" name="txtCredentials3" className='add-only' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <h3>Member Information
                </h3>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>First Name:</span>
                            <input type='text' id="txtFirstName1" name="txtFirstName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Last Name:</span>
                            <input type='text' id="txtLastName1" name="txtLastName1" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member ID:</span>
                            <input type='text' id="txtMember1" name="txtMember1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Date of Birth:</span>
                            <input id="txtFirstName2" name="txtFirstName2" className='add-only' type='date' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Diagnosis :</span><span className='small'>(Dx Code and Name)</span>
                            <input type='text' id="txtLastName2" name="txtLastName2" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Member Medical Diagnosis:</span><span className='small'>(Dx Code and Name)</span>
                            <input type='text' id="txtMember2" name="txtMember2" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does member participate in Medication Management</span><span className='small'> (check one):</span>
                    <input type="radio" id="rbImmunization_Yes" name="rbImmunization" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbImmunization_No" name="rbImmunization" className='add-only' value="0" />No
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Prescriber Name</span>
                            <input type='text' id="txtFirstName3" name="txtFirstName3" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>Last Date seen by member:</span>
                            <input id="txtLastName3" name="txtLastName3" className='add-only' type='date' />
                        </td>
                        <td className='w-250'>&nbsp;
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List of member's current medications with dosages:</span>
                    <textarea id="txtCholesterol" name="txtCholesterol" className='add-only'></textarea>
                </p>
                <h3>Agreement to Participate in Treatment
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Did provider submit a Member Choice Form signed by all needed parties?</span>
                    <input type="radio" id="rbImmunization1_Yes" name="rbImmunization1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbImmunization1_No" name="rbImmunization1" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    Date Member Choice Form was signed (MM/DD/YYYY):<input  id="txtDateMember" name="txtDateMember" className='add-only' type='date' />
                </p>
                <h4>Assessment
                </h4>
                <p className='w-750'>
                    Date of the most recent Comprehensive Behavioral Health:<input   id="txtDateMember1" name="txtDateMember1" className='add-only' type='date' />
                </p>
                <p className='w-750'>
                    Date of the most recent CA/LOCUS Assessment and scores:<input   id="txtDateMember2" name="txtDateMember2" className='add-only' type='date' />
                </p>
                <p className='w-750'>
                    **Please submit most recent signed CA/LOCUS Assessment with this authorization request
                </p>
                <h3>Requested Authorization
                </h3>
                <h4>Tip: Be sure to indicate the appropriate place of service code when you submit your claim.
                </h4>
                <table>
                    <tr>
                        <td className='w-200'>
                            <span className='eleHeader'>PROCEDURE CODES (MODIFIERS ONLY FOR SUPPORTIVE HOUSING SERVICES)</span>
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>SERVICE DATES </span><span className='small'>MM/DD/YYYY</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Frequency:<br />
                                HOW OFTEN SEEN</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>Intensity:<br />
                                # OF UNITS PER VISIT</span>
                        </td>
                        <td className='w-100'>
                            <span className='eleHeader'>TOTAL UNITS REQUESTED</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b>Community Psychiatric Support Treatment</b><br />
                            <input type="checkbox" id="chkLiving111_Home" name="chkLiving111_Home" className='add-only' value="Living111" />H0036
                        </td>
                        <td className='w-250'>Request Start:<input   id="txtRefTemp" name="txtRefTemp" className='add-only' type='date' />
                            Request End: (Standard: 60 days)<input   id="txtRefTemp1" name="txtRefTemp1" className='add-only' type='date' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtFrequency" name="txtFrequency" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtIntensity" name="txtIntensity" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtPulseInt" name="txtPulseInt" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-200'><b>Psychosocial Rehabilitative Services H2017 Individual Office or Community</b><br />
                            <input type="checkbox" id="chkLiving11_Home" name="chkLiving11_Home" className='add-only' value="Living11" />H2017<br />
                            <input type="checkbox" id="chkLiving12_Home" name="chkLiving12_Home" className='add-only' value="Living12" />H2017 Permanent Supportive Housing
                        </td>
                        <td className='w-250'>Request Start:<input   id="txtRefTemp2" name="txtRefTemp2" className='add-only' type='date' />
                            Request End: (Standard: 60 days)<input   id="txtRefTemp11" name="txtRefTemp11" className='add-only' type='date' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtFrequency1" name="txtFrequency1" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtIntensity2" name="txtIntensity2" className='add-only' />
                        </td>
                        <td className='w-100'>
                            <input type='text' id="txtPulseInt3" name="txtPulseInt3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <h3>Risk Assessment
                </h3>
                <h4>Member Risk History <span className='small'>(Within past 12 calendar months)</span>
                </h4>
                <table>
                    <tr>
                        <td className='w-100'>&nbsp;
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>None</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Mild<br />
                                Ideations only</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Moderate<br />
                                Ideations with plan of attempts</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Severe<br />
                                Ideations AND plan, with either intent or means</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Not Assessed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>To Self:
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization2_Yes" name="rbImmunization2" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization2_No" name="rbImmunization2" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization2_Ys" name="rbImmunization2" className='add-only' value="2" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbImmunization2_Nol" name="rbImmunization" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization2_Ysi" name="rbImmunization2" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>To Others:
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization11_Yes" name="rbImmunization11" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization11_No" name="rbImmunization11" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization11_Ys" name="rbImmunization11" className='add-only' value="2" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbImmunization11_Nol" name="rbImmunization11" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization11_Ysi" name="rbImmunization11" className='add-only' value="4" />
                        </td>
                    </tr>
                </table>
                <h4>Current Member Risk<span className='small'> (Within past 60 days)</span>
                </h4>
                <table>
                    <tr>
                        <td className='w-100'>&nbsp;
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>None</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Mild<br />
                                Ideations only</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Moderate<br />
                                Ideations with plan of attempts</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>Severe<br />
                                Ideations AND plan, w/ either intent or means</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Not Assessed</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>To Self:
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization21_Yes" name="rbImmunization21" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization21_No" name="rbImmunization21" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization21_Ys" name="rbImmunization21" className='add-only' value="2" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbImmunization21_Nol" name="rbImmunization21" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization21_Ysi" name="rbImmunization21" className='add-only' value="4" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-100'>To Others:
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization3_Yes" name="rbImmunization3" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization3_No" name="rbImmunization3" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization3_Ys" name="rbImmunization3" className='add-only' value="2" />
                        </td>
                        <td className='w-150'>
                            <input type="radio" id="rbImmunization3_Nol" name="rbImmunization3" className='add-only' value="3" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbImmunization3_Ysi" name="rbImmunization3" className='add-only' value="4" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Detail any past or current risk rated moderate or severe:</span>
                    <textarea id="txtDetail" name="txtDetail" className='add-only'></textarea>
                </p>
                <h3>Crisis Management / Safety Plan
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Does the member have a behavioral health crisis management or safety plan in place?</span>
                    <input type="radio" id="rbCrisis_Yes" name="rbCrisis" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbCrisis_No" name="rbCrisis" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    If yes, what is the date of the most recent plan?
                    <input   id="txtMostRecent" name="txtMostRecent" className='add-only' type='date' />
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Has member received crisis intervention services in the last 60 days?</span>
                    <input type="radio" id="rbCrisis1_Yes" name="rbCrisis1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbCrisis1_No" name="rbCrisis1" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    If YES, list dates crisis services were provided to member and describe crisis below (MM/DD/YYYY):
                    <textarea id="txtSafetyPlan1" name="txtSafetyPlan1" className='add-only'></textarea>
                </p>
                <h3>Evaluation and Treatment Planning
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Has the member (or guardian) signed the Treatment Plan and agreed to participate?</span>
                    <input type="radio" id="rbCrisis2_Yes" name="rbCrisis2" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbCrisis2_No" name="rbCrisis2" className='add-only' value="0" />No
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>TREATMENT GOALS</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>LIST ASSOCIATED SEVERE SYMPTOMS</span>
                        </td>
                        <td className='w-150'>
                            <span className='eleHeader'>PROGRESS TOWARDS MEETING GOALS: </span><span className='small'>(RENEWAL ONLY) </span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>BARRIERS TO MEETING GOALS:</span><span className='small'>(RENEWAL ONLY)</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>Goal 1:
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtTreatFrequency" name="txtTreatFrequency" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtList" name="txtList" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtMeeting" name="txtMeeting" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtMetGoal" name="txtMetGoal" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>Goal 2:
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtTreatFrequency1" name="txtTreatFrequency1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtList1" name="txtList1" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtMeeting1" name="txtMeeting1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtMetGoal1" name="txtMetGoal1" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>Goal 3:
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtTreatFrequency2" name="txtTreatFrequency2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtList2" name="txtList2" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtMeeting2" name="txtMeeting2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtMetGoal2" name="txtMetGoal2" className='add-only' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-50'>Goal 4:
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtTreatFrequency3" name="txtTreatFrequency3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtList3" name="txtList3" className='add-only' />
                        </td>
                        <td className='w-150'>
                            <input type='text' id="txtMeeting3" name="txtMeeting3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input type='text' id="txtMetGoal3" name="txtMetGoal3" className='add-only' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Additional information related to goals, progress, and barriers:</span>
                    <textarea id="txtAdditional" name="txtAdditional" className='add-only'></textarea>
                </p>
                <h3>FUNCTIONAL OUTCOMES<span className='small'>(select yes or no)</span>
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has member received inpatient or residential behavioral health care?</span>
                    <input type="radio" id="rbFunctional_Yes" name="rbFunctional" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional_No" name="rbFunctional" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has the member had problems with sleeping or feeling sad?</span>
                    <input type="radio" id="rbFunctional1_Yes" name="rbFunctional1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional1_No" name="rbFunctional1" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has the member had problems with had problems with fears and anxiety?</span>
                    <input type="radio" id="rbFunctional2_Yes" name="rbFunctional2" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional2_No" name="rbFunctional2" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has alcohol or drug use caused problems for member?</span>
                    <input type="radio" id="rbFunctional3_Yes" name="rbFunctional3" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional3_No" name="rbFunctional3" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has member gotten in trouble with the law?</span>
                    <input type="radio" id="rbFunctional4_Yes" name="rbFunctional4" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional4_No" name="rbFunctional4" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has member had trouble getting along with other people including family and people out the home?</span>
                    <input type="radio" id="rbFunctional5_Yes" name="rbFunctional5" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional5_No" name="rbFunctional5" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has member had an unstable living situation?</span>
                    <input type="radio" id="rbFunctional6_Yes" name="rbFunctional6" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional6_No" name="rbFunctional7" className='add-only' value="0" />No
                </p>
                <h4>CHILDREN ONLY
                </h4>
                <p className='w-750'>
                    <span className='eleHeader'>In the last 30 days, has member been suspended or expelled from school?</span>
                    <input type="radio" id="rbFunctional7_Yes" name="rbFunctional7" className='add-only' value="1" />
                    Yes
                    <input type="radio" id="rbFunctional7_No" name="rbFunctional7" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is member currently in state custody</span> <span className='small'>(DCFS or Juvenile Justice)?</span>
                    <input type="radio" id="rbFunctional8_Yes" name="rbFunctional8" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional8_No" name="rbFunctional8" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is member currently attending traditional school?</span>
                    <input type="radio" id="rbFunctional9_Yes" name="rbFunctional9" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional9_No" name="rbFunctional9" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    If NO, List school member attends (alternative school, homebound services, etc)
                    <textarea id="txtAdditionalSchool" name="txtAdditionalSchool" className='add-only'></textarea>
                </p>
                <h4>ADULTS ONLY</h4>
                <p className='w-750'>
                    <span className='eleHeader'>Is member currently employed?</span>
                    <input type="radio" id="rbFunctional11_Yes" name="rbFunctional11" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional11_No" name="rbFunctional11" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Is member currently in school?</span>
                    <input type="radio" id="rbFunctional12_Yes" name="rbFunctional12" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional12_No" name="rbFunctional12" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Does member have stable housing?</span>
                    <input type="radio" id="rbFunctional13_Yes" name="rbFunctional13" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbFunctional13_No" name="rbFunctional13" className='add-only' value="0" />No
                </p>
                <h3>SYMPTOMS <span className='small'>(IF PRESENT, SELECT DEGREE TO WHICHIT IMPACTS DAILY FUNCTIONING.)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>N/A</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Mild</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Moderate</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Severe</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Anxiety/Panic Attacks
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere_Yes" name="rbSevere" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere_No" name="rbSevere" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere_Ys" name="rbSevere" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere_Nol" name="rbSevere" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Hyperactivity
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere1_Yes" name="rbSevere1" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere1_No" name="rbSevere1" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere1_Ys" name="rbSevere1" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere1_Nol" name="rbSevere1" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Decreased Energy
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere2_Yes" name="rbSevere2" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere2_No" name="rbSevere2" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere2_Ys" name="rbSevere2" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere2_Nol" name="rbSevere2" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Inattention
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere3_Yes" name="rbSevere3" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere3_No" name="rbSevere3" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere3_Ys" name="rbSevere3" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere3_Nol" name="rbSevere3" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Depressed Mood
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere4_Yes" name="rbSevere4" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere4_No" name="rbSevere4" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere4_Ys" name="rbSevere4" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere4_Nol" name="rbSevere4" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Impulsivity
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere5_Yes" name="rbSevere5" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere5_No" name="rbSevere5" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere5_Ys" name="rbSevere5" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere5_Nol" name="rbSevere5" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Hopelessness
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere6_Yes" name="rbSevere6" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere6_No" name="rbSevere6" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere6_Ys" name="rbSevere6" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere6_Nol" name="rbSevere6" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Mood Swings
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere7_Yes" name="rbSevere7" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere7_No" name="rbSevere7" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere7_Ys" name="rbSevere7" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere7_Nol" name="rbSevere7" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Social Withdrawal
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere8_Yes" name="rbSevere8" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere8_No" name="rbSevere8" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere8_Ys" name="rbSevere8" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere8_Nol" name="rbSevere8" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Outbursts/Anger
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere9_Yes" name="rbSevere9" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere9_No" name="rbSevere9" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere9_Ys" name="rbSevere9" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere9_Nol" name="rbSevere9" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <h3>FUNCTIONAL IMPAIRMENT<span className='small'>
                    (IF PRESENT, SELECT DEGREE TO WHICH IT IMPACTS DAILY FUNCTIONING.)</span>
                </h3>
                <table>
                    <tr>
                        <td className='w-250'>&nbsp;
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>N/A</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Mild</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Moderate</span>
                        </td>
                        <td className='w-125'>
                            <span className='eleHeader'>Severe</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Personal Hygiene
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere11_Yes" name="rbSevere11" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere11_No" name="rbSevere11" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere11_Ys" name="rbSevere11" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere11_Nol" name="rbSevere11" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Physical Health
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere12_Yes" name="rbSevere12" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere12_No" name="rbSevere12" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere12_Ys" name="rbSevere12" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere12_Nol" name="rbSevere12" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Sleep
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere13_Yes" name="rbSevere13" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere13_No" name="rbSevere13" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere13_Ys" name="rbSevere13" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere13_Nol" name="rbSevere13" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Work/School
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere14_Yes" name="rbSevere14" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere14_No" name="rbSevere14" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere14_Ys" name="rbSevere14" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere14_Nol" name="rbSevere14" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Medication Compliance
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere15_Yes" name="rbSevere15" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere15_No" name="rbSevere15" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere15_Ys" name="rbSevere15" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere15_Nol" name="rbSevere15" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Relationships
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere16_Yes" name="rbSevere16" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere16_No" name="rbSevere16" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere16_Ys" name="rbSevere16" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere16_Nol" name="rbSevere16" className='add-only' value="3" />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-250'>Substance Use (Current)
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere17_Yes" name="rbSevere17" className='add-only' value="1" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere17_No" name="rbSevere17" className='add-only' value="0" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere17_Ys" name="rbSevere17" className='add-only' value="2" />
                        </td>
                        <td className='w-125'>
                            <input type="radio" id="rbSevere17_Nol" name="rbSevere17" className='add-only' value="3" />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>List Substance Used:</span>
                    <textarea id="txtSubstance" name="txtSubstance" className='add-only'></textarea>
                </p>
                <h3>Previous Treatment Service Coordination
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Has member received any previous behavioral health services </span><span className='small'>(inpatient or residential, substance use, counseling, medication management, assessment, etc...)</span>
                    <input type="radio" id="rbImmunizationTreatment_Yes" name="rbImmunizationTreatment" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbImmunizationTreatment_No" name="rbImmunizationTreatment" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <strong>If yes, list services below with dates.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-175'>
                            <span className='eleHeader'>Services Received</span>
                        </td>
                        <td className='w-175'>
                            <span className='eleHeader'>Provider Name</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date Started </span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date Ended</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <input type='text' id="txtServicesReceived" name="txtServicesReceived" className='add-only' />
                        </td>
                        <td className='w-175'>
                            <input type='text' id="txtProviderName" name="txtProviderName" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input   id="txtDateStarted" name="txtDateStarted" className='add-only' type='date' />
                        </td>
                        <td className='w-200'>
                            <input   id="txtDateEnded" name="txtDateEnded" className='add-only' type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <input type='text' id="txtServicesReceived1" name="txtServicesReceived1" className='add-only' />
                        </td>
                        <td className='w-175'>
                            <input type='text' id="txtProviderName1" name="txtProviderName1" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input    id="txtDateStarted1" name="txtDateStarted1" className='add-only' type='date' />
                        </td>
                        <td className='w-200'>
                            <input   id="txtDateEnded1" name="txtDateEnded1" className='add-only' type='date' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>Does member participate in with any agencies that would require coordination of care </span><span className='small'>(DCFS, CSOC, FINS, OJJ, probation, court, Wrap Around Agency, etc...)</span>
                    <input type="radio" id="rbImmunizationTreatment1_Yes" name="rbImmunizationTreatment1" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbImmunizationTreatment1_No" name="rbImmunizationTreatment1" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    <strong>If yes, list services below with dates.</strong>
                </p>
                <table>
                    <tr>
                        <td className='w-175'>
                            <span className='eleHeader'>Services Received</span>
                        </td>
                        <td className='w-175'>
                            <span className='eleHeader'>Contact Name</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Date Started</span>
                        </td>
                        <td className='w-200'>
                            <span className='eleHeader'>Last Visit</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <input type='text' id="txtServicesReceived2" name="txtServicesReceived2" className='add-only' />
                        </td>
                        <td className='w-175'>
                            <input type='text' id="txtProviderName2" name="txtProviderName2" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input   id="txtDateStarted2" name="txtDateStarted2" className='add-only' type='date' />
                        </td>
                        <td className='w-200'>
                            <input   id="txtDateEnded2" name="txtDateEnded2" className='add-only' type='date' />
                        </td>
                    </tr>
                    <tr>
                        <td className='w-175'>
                            <input type='text' id="txtServicesReceived3" name="txtServicesReceived3" className='add-only' />
                        </td>
                        <td className='w-175'>
                            <input type='text' id="txtProviderName3" name="txtProviderName3" className='add-only' />
                        </td>
                        <td className='w-200'>
                            <input   id="txtDateStarted3" name="txtDateStarted3" className='add-only' type='date' />
                        </td>
                        <td className='w-200'>
                            <input   id="txtDateEnded3" name="txtDateEnded3" className='add-only' type='date' />
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <span className='eleHeader'>If applicable, provide a summary of last meeting with agency above:</span>
                    <textarea id="txtSubstance12" name="txtSubstance12" className='add-only'></textarea>
                </p>
                <h3>Discharge Planning
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Have you discussed the discharge plan from the requested services with the member?</span>
                    <input type="radio" id="rbImmunizationTreatment11_Yes" name="rbImmunizationTreatment11" className='add-only' value="1" /> Yes &nbsp;
                    <input type="radio" id="rbImmunizationTreatment11_No" name="rbImmunizationTreatment11" className='add-only' value="0" />No
                </p>
                <p className='w-750'>
                    Target discharge date from the requested services:<input   id="txtDateTarget" name="txtDateTarget" className='add-only' type='date' />
                </p>
                <h3>Additional Information:
                </h3>
                <p className='w-750'>
                    <span className='eleHeader'>Please provide any additional information to help support your request for medical necessity including any assessments that may have been completed.</span>
                    <textarea id="txtAdditionalInformation" name="txtAdditionalInformation" className='add-only'></textarea>
                </p>
                <h3>Member Attendance and Engagement <span className='small'>(Renewal Requests Only)</span>
                </h3>
                <table>
                    <tr> 
                        <td className='w-750'>
                            <span className='eleHeader'>Since the last outpatient treatment request, did the member attend and engage in the requested services?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-150'>
                            <input type="radio" id="rbImmunizationMember_Yes" name="rbImmunizationMember" className='add-only' value="1" />
                            Fully (100%)
                        </td>
                        <td className='w-200'>
                            <input type="radio" id="rbImmunizationMember_No" name="rbImmunizationMember" className='add-only' value="0" />
                            Partially (70% - 99%)
                        </td>
                        <td className='w-200'>
                            <input type="radio" id="rbImmunizationMember_Ys" name="rbImmunizationMember" className='add-only' value="2" />
                            Poorly (50% - 69%)
                        </td>
                        <td className='w-200'>
                            <input type="radio" id="rbImmunizationMember_Nol" name="rbImmunizationMember" className='add-only' value="3" />
                            Did Not (0% - 50%)
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='w-750'>
                            <span className='eleHeader'>If member did not fully participate, why not?</span>
                        </td>
                    </tr>
                    <tr>
                        <td className='w-375'>
                            <input type="checkbox" id="chkLivingMember1_Home" name="chkLivingMember1_Home" className='add-only' value="LivingMember1" />
                            Member had inpatient hospitalization
                        </td>
                        <td className='w-375'>
                            <input type="checkbox" id="chkLivingMember2_Home" name="chkLivingMember2_Home" className='add-only' value="LivingMember2" />
                            Member was incarcerated
                        </td>
                    </tr>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLivingMember3_Home" name="chkLivingMember3_Home" className='add-only' value="LivingMember3" />
                            Member with continued non-compliance to MHR treatment schedule (explain below)
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAdditionalInformation2" name="txtAdditionalInformation2" className='add-only'></textarea>
                </p>
                <table>
                    <tr>
                        <td className='w-750'>
                            <input type="checkbox" id="chkLivingMember4_Home" name="chkLivingMember4_Home" className='add-only' value="LivingMember4" />
                            Other (explain hospitalization below):
                        </td>
                    </tr>
                </table>
                <p className='w-750'>
                    <textarea id="txtAdditionalInformation5" name="txtAdditionalInformation5" className='add-only'></textarea>
                </p>
                <p className='w-750'>
                    <span className='eleHeader'>Explanation for poor participation, refusal of participation, MHR treatment schedule, or other reason(s) provider indicates member did not fully participate in treatment:</span>
                    <textarea id="txtAdditionalInformation6" name="txtAdditionalInformation6" className='add-only'></textarea>
                </p>
                <h3>Attestation of Licensed Clinician<span className='small'> (Required for ALL Requests)</span>
                </h3>
                <p className='w-750'>
                    It is important to the health outcomes of our members that licensed providers are actively engaged in the mental health rehabilitation services delivered under their supervision. The Louisiana Department of Health Behavioral Health Provider Manual also emphasizes the importance of active supervision by a licensed provider:
                </p>
                <p className='w-750'>
                    "The medical necessity for these rehabilitative services must be determined by and services recommended by a licensed mental health professional or physician, or under the direction of a licensed practitioner, to promote the maximum reduction of symptoms and restoration to his/her best age appropriate functional level."
                </p>
                <p className='w-750'>
                    <strong>By signing below, I, a licensed mental health clinician, attest that:</strong>
                </p>
                <p className='w-750'>
                    The LOCUS/CALOCUS assessment was completed by myself (or another licensed mental health clinician at my agency) face-to-face directly with the member, or in the case of a pre-verbal minor, face-to-face directly with the member's legal guardian.
                </p>
                <p className='w-750'>
                    The Treatment Plan was developed by myself (or another licensed mental health clinician at my agency), and the member has been determined to have the ability to participate in and benefit from this Treatment Plan.
                </p>
                <p className='w-750'>
                    I have determined the requested services are medically necessary and the contents of this Outpatient Treatment Request are true and accurate.
                </p>
                <table>
                    <tr>
                        <td className='w-250'>
                            <span className='eleHeader'>Clinician:</span>
                            <input type='text' id="txtClinician4" name="txtClinician4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>License #:</span>
                            <input type='text' id="txtCredentials4" name="txtCredentials4" className='add-only' />
                        </td>
                        <td className='w-250'>
                            <span className='eleHeader'>NPI:</span>
                            <input type='text' id="txtAgencyName4" name="txtAgencyName4" className='add-only' />
                        </td>
                    </tr>
                </table>
                <table>
                    <tr>
                        <td className='signature w-550'>&nbsp; </td>
                        <td  className='signature w-200'>&nbsp; </td>
                    </tr>
                    <tr>
                        <td className='small w-550'>Signature
                        </td>
                        <td className='small w-200'>Date:
                        </td>
                    </tr>
                </table>






            </div>
        </form>

    )
}











